module.exports = __webpack_public_path__ + "static/bytovka1-3f2bba0fec28b1c9975001a2f864226f.jpeg";